var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardPage',[[_c('GroupChartCard',{staticClass:"card",attrs:{"loading":_vm.breachesStatisticsLoading,"title":_vm.$t('statistics.breaches.title').toString(),"identifier":"breaches","data":_vm.breaches,"rows":2}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }